module.exports = __webpack_public_path__ + "img/spade.3274d318.svg";